import axios from '../config/configSAP';

export const Login = (body) => axios.post(`Login`, body);